module.exports = __webpack_public_path__ + "img/about_us.e11f3c66.png";